import React, { FC } from "react";
import { Path, Rect, Svg, SvgProps } from "react-native-svg";

const ShareIcon: FC<SvgProps> = (props) => {
  return (
    <Svg
      width={props.width}
      height={props.width}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Rect width={props.width} height={props.width} fill="none" />
      <Path
        d="M17 15C19.0703 15 20.75 16.6797 20.75 18.75C20.75 20.8203 19.0703 22.5 17 22.5C14.9297 22.5 13.25 20.8203 13.25 18.75C13.25 18.2422 13.3281 17.7734 13.5234 17.3438L9.77344 15C9.10938 15.7812 8.09375 16.25 7 16.25C4.92969 16.25 3.25 14.5703 3.25 12.5C3.25 10.4297 4.92969 8.75 7 8.75C8.09375 8.75 9.10938 9.25781 9.77344 10.0391L13.5234 7.69531C13.3281 7.26562 13.25 6.75781 13.25 6.25C13.25 4.17969 14.9297 2.5 17 2.5C19.0703 2.5 20.75 4.17969 20.75 6.25C20.75 8.32031 19.0703 10 17 10C15.8672 10 14.8516 9.53125 14.1875 8.75L10.4375 11.0938C10.8281 11.9922 10.8281 13.0469 10.4375 13.9453L14.1875 16.2891C14.8516 15.5078 15.8672 15 17 15ZM17 3.75C15.5938 3.75 14.5 4.88281 14.5 6.25C14.5 7.65625 15.5938 8.75 17 8.75C18.3672 8.75 19.5 7.65625 19.5 6.25C19.5 4.88281 18.3672 3.75 17 3.75ZM7 15C8.36719 15 9.5 13.9062 9.5 12.5C9.5 11.1328 8.36719 10 7 10C5.59375 10 4.5 11.1328 4.5 12.5C4.5 13.9062 5.59375 15 7 15ZM17 21.25C18.3672 21.25 19.5 20.1562 19.5 18.75C19.5 17.3828 18.3672 16.25 17 16.25C15.5938 16.25 14.5 17.3828 14.5 18.75C14.5 20.1562 15.5938 21.25 17 21.25Z"
        fill={props.color || "#71706F"}
      />
    </Svg>
  );
};

export default ShareIcon;
